import { imageData } from '/src/constants/constants.jsx';
import React, { useEffect, useRef, useState } from 'react';

const Video = () => {
    const videoRef = useRef(null);

    // State to hold the randomly selected video
    const [selectedVideo, setSelectedVideo] = useState(null);

    // Randomly pick a video when the component mounts
    useEffect(() => {
        const randomIndex = Math.floor(
            Math.random() * imageData.banner_video_list.length,
        );
        setSelectedVideo(imageData.banner_video_list[randomIndex].url); // Set the selected video
    }, []);

    // // Optional: Adjust playback speed
    // useEffect(() => {
    //     if (videoRef.current) {
    //         videoRef.current.playbackRate = 1.0; // Adjust speed to 1/2
    //     }
    // }, []);

    return selectedVideo ? (
        <video
            ref={videoRef}
            className="video_background"
            autoPlay
            loop
            muted
            playsInline>
            <source src={selectedVideo} type="video/mp4" />
            {/* Fallback */}
        </video>
    ) : null;
};

export default Video;
